<template>
  <div class="cherryPick">
    <div @click="toAdlink">
      <!--<div class="panelBottom" :style="'background-image:url(' + midAd.adPicture + ')'" v-if="midAd.adPicture"></div>-->
      <el-image class="panelBottom" :src="midAd.adPicture" fit="contain" v-if="midAd.adPicture"></el-image>
    </div>
    <div class="listTitle">
      <!-- <img src="../../../assets/images/mall/qiruiFind.png" alt=""> -->
      <h1>{{ otherTitle }}</h1>
      <span @click="toMallJp" v-if="list.length > 10">
        <i id="triangle-topleft"></i>
        查看全部
      </span>
    </div>
    <div class="listPanel">
      <div class="cp_productList-best" v-if="list.length > 0">
        <div class="cp_productCard" v-for="(item, i) in list.slice(0, 10)" :key="i">
          <div v-if="item.id">
            <router-link :to="adRoute(item).url + item.id" class="product-link">
              <div class="sukText" v-if="item.activityItemInfoDto && item.activityItemInfoDto.activityInfoDto">
                <!-- <div
                  v-if="
                    item.activityItemInfoDto &&
                      item.activityItemInfoDto.activityInfoDto &&
                      item.activityItemInfoDto.activityInfoDto.activityStatus === 1 &&
                      item.activityItemInfoDto.activityInfoDto.realStartTime < now &&
                      item.activityItemInfoDto.activityInfoDto.realEndTime > now &&
                      item.activityItemInfoDto.ifDisplay === true
                  "
                >
                  仅剩<span>{{ item.activityItemInfoDto.activityInfoDto.recordCount }}</span
                  >{{ item.type == '0' ? '台' : '件' }}
                </div> -->
              </div>
              <!-- 秒杀 -->
              <div class="Deposit DepositAc6">
                <span class="other-text">{{ midAd.subhead.substr(0, 3) }}</span>
              </div>
              <!--<div class="productImage2" :style="'background-image:url(' + item.mainImage + ')'"></div>-->
              <el-image class="productImage2" :src="item.mainImage" fit="contain"></el-image>
              <div class="productDetail">
                <p class="productName2" v-text="item.name"></p>
                <p class="productDiscount2" v-text="item.advertise"></p>
                <div id="activityPro" v-if="adRoute(item).type === 'flashSale'" style="width: 220px; padding: 0px 20px">
                  <div id="activityProPrice" style="font-size: 16px; font-weight: 500; color: #c6001f; margin: 7px 0">
                    <span>
                      {{
                        item.activityItemInfoDto &&
                        item.activityItemInfoDto.activityItemDtoList &&
                        item.activityItemInfoDto.activityItemDtoList[0].itemExtDto
                          ? item.activityItemInfoDto.activityItemDtoList[0].itemExtDto.activityPrice
                          : item.price | currency('￥', 2)
                      }}
                    </span>
                    <!-- <span style="text-decoration: line-through; color: #666666; font-size: 14px">{{
                      item.price | currency('￥', 2)
                    }}</span> -->
                  </div>
                  <!-- <el-button
                    v-if="item.activityItemInfoDto && item.activityItemInfoDto.activityInfoDto"
                    style="width: 220px; background-color: #c6001f; border-color: #c6001f; border-radius: 0"
                    type="danger"
                    >立即抢购</el-button
                  > -->
                </div>
                <div class="proDe" v-else>
                  <p class="productPrice">
                    {{ adRoute(item).type === 'secondKill' ? '秒杀价' : '' }}
                    {{
                      item.activityItemInfoDto &&
                      item.activityItemInfoDto.activityInfoDto &&
                      item.activityItemInfoDto.activityInfoDto.activityType != 3 &&
                      item.activityItemInfoDto.activityItemDtoList &&
                      item.activityItemInfoDto.activityItemDtoList[0].itemExtDto
                        ? item.activityItemInfoDto.activityItemDtoList[0].itemExtDto.activityPrice
                        : item.price | currency('￥', 2)
                    }}
                  </p>
                </div>
              </div>
            </router-link>
          </div>
          <div v-else>
            <!--<div class="productImage3" :style="'background-image:url(' + item.mainImage + ')'"></div>-->
            <el-image class="productImage3" :src="item.mainImage" fit="contain"></el-image>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ActivityRoute } from '@/lib/utils'
export default {
  name: '',
  data() {
    return {
      now: 0,
      list: [],
      qrjxTitle: '自定义楼层',
      midAd: {}
    }
  },
  props: {
    otherList: {
      type: Object,
      default: () => {}
    }
  },
  created() {
    this.now = new Date().getTime()
    const midAd = this.otherList
    if (midAd) {
      this.otherTitle = midAd.title
      this.midAd = midAd
    }
    this.list = midAd ? midAd.itemList || [] : []
  },
  components: {},
  methods: {
    adRoute(attr, productType) {
      return ActivityRoute(attr, productType)
    },
    toMallJp() {
      this.$router.push({
        path: '/seller/mallJp'
      })
    },
    toAdlink() {
      if (this.midAd.adLink) {
        window.location.href = this.midAd.adLink
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.cherryPick {
  width: 1360px;
  min-width: 1200px;
  margin: 0px auto;
}
.listTitle {
  width: 100%;
  height: 70px;
  font-size: 22px;
  font-family: 'NotoSansHans-Bold';
  font-weight: bold;
  // margin-bottom: 20px;
  padding-top: 12px;
  // background-color: lightblue;
  display: flex;
  justify-content: space-between;
  align-items: center;
  > img {
    width: 128px;
    height: 27px;
  }
  h1 {
    height: 42px;
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
    line-height: 42px;
    padding-left: 24px;
    position: relative;
  }
  h1:after {
    content: '';
    width: 4px;
    height: 24px;
    background: #c6001f;
    position: absolute;
    left: 0;
    top: 10px;
  }
  span {
    display: inline-block;
    width: 130px;
    height: 34px;
    font-size: 18px;
    font-weight: 400;
    font-family: PingFangSC-Semibold, PingFang SC;
    color: #ffffff;
    background: #000000 url('../../../assets/images/mall/see-more-arrow.png') no-repeat 110px center;
    background-size: 14px;
    #triangle-topleft {
      width: 0;
      height: 0;
      border-top: 34px solid#F5F5F5;
      border-right: 12px solid transparent;
      margin-right: 16px;
    }
  }
  // span:hover {
  //   background: url('../../../assets/images/mall/more-check.png') no-repeat right center;
  //   background-size: 20px 20px;
  // }
}
.listTitle > span:first-child {
  font-size: 32px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  /* background-color: lightcoral; */
  padding: 0px;
}
.listTitle > span:last-child {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.listPanel > span:last-child {
  font-size: 20px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.listTitle > span > img {
  margin-left: 6px;
}
.listPanel {
  width: 100%;
  min-height: 315px;
}
.cp_productList-best {
  width: 1360px;
  /* background-color: lightsalmon; */
  .cp_productCard:nth-child(6),
  .cp_productCard:nth-child(1) {
    margin-left: 0px;
  }
  .cp_productCard {
    width: 260px;
    height: 315px;
    position: relative;
    float: left;
    margin-left: 15px;
    margin-bottom: 20px;
    background: white;
    transition: all 0.2s linear;
    .sukText {
      position: absolute;
      left: 10px;
      top: 0;
      height: 22px;
      font-size: 14px;
      font-weight: 400;
      color: #333;
      line-height: 22px;
      margin: 10px 0 0 20px;
      span {
        color: #c6001f;
      }
    }
    .Deposit {
      z-index: 2;
      position: absolute;
      width: 60px;
      height: 66px;
      top: 0;
      right: 0;
    }
    .other-text {
      position: absolute;
      top: 14px;
      width: 50px;
      text-align: center;
      right: -3px;
      color: #fff;
      font-size: 16px;
      transform: rotate(45deg);
      display: inline-block;
    }
    .secondKill {
      background-image: url('../../../assets/secondKill.png');
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
    }
    .DepositAc6 {
      height: 66px;
      width: 60px;
      background-size: 60px 66px;
      background-image: url('../../../assets/flag.png');
    }
    &:hover {
      top: -3px;
      box-shadow: 0px 4px 10px 0px rgba(27, 50, 71, 0.22);
    }
    a {
      text-decoration: none;
    }
    .productImage2 {
      width: 260px;
      height: 150px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      overflow: hidden;
    }
    .productImage3 {
      width: 260px;
      height: 315px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      overflow: hidden;
    }
    .productDetail {
      .productName2 {
        margin-top: 10px;
        padding: 0px 20px;
        color: #000000;
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 2px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .productDiscount2 {
        height: 60px;
        box-sizing: border-box;
        padding-top: 5px;
        margin-top: 5px;
        // margin-bottom: 10px;
        font-size: 14px;
        line-height: 20px;
        font-weight: 400;
        color: #666666;
        padding: 0px 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .productPrice {
        margin: 7px 0;
        padding: 0px 20px;
        font-size: 16px;
        font-weight: 500;
        color: #c6001f;
      }
    }
  }
}
.panelBottom {
  width: 1360px;
  height: 200px;
  background-color: rgba(255, 255, 255, 1);
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  margin-top: 20px;
  overflow: hidden;
  // box-shadow: 0px 4px 10px 0px rgba(27, 50, 71, .22);
}
</style>
